
import { defineComponent } from "vue";
import slideInfo from "../slide-info/slide-info.vue";

export default defineComponent({
  components: { slideInfo },

  data() {
    return {
      decorateList: [
        // { position: 'top-right', url: require('/src/assets/images/home_pic3_bg2.png'), width: 33 },
      ]
    };
  }
});
